import { copyFileSync } from "fs";
import ResultValue from "../types/ResultValue";

function sumAll(results: any[], field: string) {
  var values = results.map(x => x[field]);
  if (values.every(x => (x != null))) {
    return values.reduce((x, xp) => xp + x, 0);
  } else {
    return undefined;
  } 
}

function getTotalDto(results: ResultValue[], discount?: number): any {
  var total = {
    price:  sumAll(results,"price"),
    netPrice: sumAll(results, "netPrice"),
    weight: sumAll(results, "weight")
  }
  return total;
}

function calculateDiscounted(initialPrice?: number, discount?: number): string {
  if (initialPrice == null) return "";
  var actualDiscount = discount != null ? discount : 0.0;
  return (initialPrice * (1.0 - actualDiscount / 100.0)).toFixed(2);
}

function calculateNetPrice(quantity?: number, price?: number, discount?: number) {
  if (price == null) return 0;
  if (quantity == null) return 0;
  var actualDiscount = discount ? (100 - discount) : 0.0;
  return (quantity * (price * (actualDiscount > 0 ? (actualDiscount / 100) : 1)));
}

export { getTotalDto, calculateDiscounted, sumAll, calculateNetPrice };
